<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="1500px" @close="close()">
    <div slot="content">
      <el-row type="flex" justify="space-between">
        <!-- 태스크 정의 -->
        <el-col :span="16" class="mr-r20">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 mr-r15">태스크 정의</div>
              <div class="setting-addel">
                <el-button size="mini" @click="onAddButtonClick"><i class="fas fa-plus"></i></el-button>
                <el-button size="mini" :disabled="!checkedRows.length" @click="onDeleteButtonClick"><i class="fas fa-minus"></i></el-button>
              </div>
            </div>
            <div class="vertical-center-box" align="right">
              <w-header-search-button size="mini" @click="showTaskDefSearchTool = !showTaskDefSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="taskDefTable" :column-default="columnDefault" :data="taskDefData" :columns="tableColumns.taskDef" :show-search-tool="showTaskDefSearchTool"
          :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total.taskDef"
          @row-dblclick="onRowDblClick" @selection-change="onSelectionChange" @condition-change="loadData('taskDef')" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
            <template slot-scope="scope" slot="detail-slot">
              <span><i class="far fa-search-plus c-pointer" @click.stop="onClickDetailButton(scope.row)"></i></span>
            </template>
          </el-table-wrapper>
        </el-col>
        <!-- 태스크 변수 -->
        <el-col :span="8">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 mr-r15">태스크 변수</div>
              <el-button size="mini" @click="onClickTaskVarEditButton">변수 선택</el-button>
            </div>
            <div class="vertical-center-box" align="right">
              <w-header-search-button size="mini" @click="showTaskVarSearchTool = !showTaskVarSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="taskVarTable" :column-default="columnDefault" :data="taskVarData" :columns="tableColumns.taskVar"
          :show-search-tool="showTaskVarSearchTool" :show-custom-header="true" remote pagination :total="total.taskVar"
          @condition-change="loadData('taskVar')" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
          </el-table-wrapper>
        </el-col>
      </el-row>

      <w-task-def-setting-popup :selected-task="selectedTask" :selected-task-def="selectedTaskDef" :var-def-grp-list="varDefGrpList" @re-load="loadData('taskDef')" ref="taskDefSettingPopup"></w-task-def-setting-popup>
      <w-task-var-setting-popup :selected-task="selectedTask" :origin-task-var-list="originTaskVarList" @re-load="loadData('taskVar')" ref="taskVarSettingPopup"></w-task-var-setting-popup>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault, defaultPagination } from '@/constants/table';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import WTaskDefSettingPopup from './TaskDefSettingPopup';
import WTaskVarSettingPopup from './TaskVarSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WTaskDetailListPopup',
  components: {
    WTaskDefSettingPopup,
    WTaskVarSettingPopup,
  },
  props: {
    selectedTask: {
      type: Object,
      default: () => ({ taskName: EMPTY_TEXT }),
    },
    varDefGrpList: Array,
  },
  data() {
    return {
      pagination,
      EMPTY_TEXT,
      columnDefault,
      total: {
        taskDef: 0,
        taskVar: 0,
      },
      showTaskDefSearchTool: false,
      showTaskVarSearchTool: false,
      tableColumns: {
        taskDef: [
          { type: 'selection' },
          { prop: 'variableId', label: '변수 아이디', width: 100, searchable: true, sortable: true, formatter: defaultFormatter },
          { prop: 'osName', label: 'OS', width: 100, searchable: true, sortable: true },
          { prop: 'distributorName', label: '공급자', width: 100, searchable: true, sortable: true },
          { prop: 'versionName', label: '버전', width: 100, searchable: true, sortable: true },
          { prop: 'archName', label: '아키텍처', width: 100, searchable: true, sortable: true },
          { prop: 'defineValue', label: '정의 ', searchable: true, sortable: true, formatter: defaultFormatter },
        ],
        taskVar: [
          { prop: 'variableId', label: '변수 아이디', width: 200, searchable: true, sortable: true, remoteProp: 'atv.variable_id' },
          { prop: 'variableName', label: '변수명', searchable: true, sortable: true, remoteProp: 'avd.variable_name', formatter: defaultFormatter },
        ],
      },
      selectedTaskDef: null,
      taskDefData: [],
      taskVarData: [],
      checkedRows: [],
      originTaskVarList: [],
    };
  },
  computed: {
    popupTitle() {
      const selectedTask = this.selectedTask;
      return isNil(selectedTask) ? '' : `${selectedTask.taskName} 태스크`;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.showTaskDefSearchTool = false;
      this.showTaskVarSearchTool = false;
      this.$refs.taskDefTable.clearFilter();
      this.$refs.taskVarTable.clearFilter();
      this.$refs.taskDefTable.getTable().clearSelection();
      this.$refs.taskVarTable.getTable().clearSelection();
    },
    loadData(targetType) {
      if (isNil(targetType) || targetType === 'taskDef') {
        const tableParams = this.$refs.taskDefTable.getParameter();
        amsSettingsApi.getTaskDefList({ taskId: this.selectedTask.taskId, ...tableParams }).then((response) => {
          if (response.data.success) {
            this.taskDefData = response.data.data;
            this.total.taskDef = response.data.total;
          }
        });
      }
      if (isNil(targetType) || targetType === 'taskVar') {
        const tableParams = this.$refs.taskVarTable.getParameter();
        amsSettingsApi.getTaskVarList({ taskId: this.selectedTask.taskId, ...tableParams }).then((response) => {
          if (response.data.success) {
            this.taskVarData = response.data.data;
            this.total.taskVar = response.data.total;
          }
        });
      }
    },
    onAddButtonClick() {
      this.selectedTaskDef = null;
      this.$nextTick(() => {
        this.$refs.taskDefSettingPopup.open();
      });
    },
    onClickTaskVarEditButton() {
      this.originTaskVarList = cloneDeep(this.taskVarData);
      this.$nextTick(() => {
        this.$refs.taskVarSettingPopup.open();
      });
    },
    onRowDblClick(row) {
      this.selectedTaskDef = row;
      this.$nextTick(() => {
        this.$refs.taskDefSettingPopup.open();
      });
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    onDeleteButtonClick() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = '태스크 정의';
        const action = msgUtil.action.DELETE;
        amsSettingsApi.deleteTaskDefList(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TaskSetting/popup/TaskDetailListPopup.vue